import { render, staticRenderFns } from "./ExpressPoshtaReportModule.vue?vue&type=template&id=42fbcd68"
import script from "./ExpressPoshtaReportModule.vue?vue&type=script&lang=js"
export * from "./ExpressPoshtaReportModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports